import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import secureStorage from "./utils/secureStorage";

// Dynamically import all JSON files from locales/en and locales/fr
function importAll(r) {
  return r.keys().reduce((acc, key) => {
    const data = r(key);
    // If the JSON is default-exported, use .default
    const obj = data.default || data;
    return { ...acc, ...obj };
  }, {});
}

const enTranslations = importAll(require.context("./locales/en", false, /\.json$/));
const frTranslations = importAll(require.context("./locales/fr", false, /\.json$/));
const spTranslations = importAll(require.context("./locales/sp", false, /\.json$/));

const resources = {
  en: { translation: enTranslations },
  fr: { translation: frTranslations },
  sp: { translation: spTranslations },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  secureStorage.setItem('appLanguage', lng);
});

export default i18n;